import React, {SVGProps} from 'react';
import {UPLOAD_IMAGE} from '../../../constants/images.constants';

const SvgUpload = (props: SVGProps<SVGSVGElement>) => {
	return <img src={UPLOAD_IMAGE} style={{ width: '90%', height: '90%' }} />;
};

export default SvgUpload;
